export const IrisColors = {
    irisLogoBlue: "#002d62",
    irisLogoRed: "#da262e",
    irisBlack: "#0A0B0A",
    secondaryBlue: "#4c83bc",
    grey: "#ababab",
    backgroundGrey: "#e8e8e8",
    white: "#fff",
    shadow: "#9e9e9e",
    green: "#6abc4c"
};